import { Button, ImprTooltip } from '@imprivata-cloud/components';
import { useTranslation } from 'react-i18next';
import TrashIcon from '../../assets/icons/trash.svg?react';
import RevokeConsent from '../../assets/icons/revoke-consent.svg?react';
import './AuthenticatorActionItems.less';

type AuthenticatorTableRecordProps = {
  key: string;
  factorType: string;
  assuranceType?: string;
  onRemove: () => void;
  onRevokeConsent?: () => void;
};

const AuthenticatorActionItems = (prop: AuthenticatorTableRecordProps) => {
  const { t } = useTranslation();
  return (
    <div className="auth-action-items">
      {!!prop.onRevokeConsent && (
        <ImprTooltip title={t('self-service.authenticator-list.revoke-consent-tooltip')}>
          <Button type="text" className="revoke-consent-btn" icon={<RevokeConsent />} onClick={prop?.onRevokeConsent} />
        </ImprTooltip>
      )}

      <ImprTooltip title={t('self-service.authenticator-list.remove-tooltip')}>
        <Button type="text" className="remove-btn" icon={<TrashIcon />} onClick={prop?.onRemove} />
      </ImprTooltip>
    </div>
  );
};

export default AuthenticatorActionItems;
